import { useAppSelector } from "app/store";

export const useTaxType = (): string => {
  return useAppSelector((state) => state.settings.taxType) || "USETAX";
};
